import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

import {
    StaggeredFeatureList,
    featureDataProps
} from "../../../../../../patterns/staggered-feature-list/staggered-feature-list";

import {
    getStaggaredDoubleFeautureFirstImage,
    getStaggaredDoubleFeautureSecondImage
} from "./components/assets/localized-images";

const BuildAndSupportDoubleFeatureSection = () => {
    const intl = useIntl();

    const featureData: featureDataProps[] = [
        {
            headingText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-header-text",
                defaultMessage: "Everything in one place"
            }),
            bodyText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-body-text",
                defaultMessage:
                    "The context you need, when you need it. See software team release dates, real-time views of Figma designs, and more, all inside Jira."
            }),
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                defaultMessage: "Explore features"
            }),
            linkUrl: useLocalizedHref("/software/jira/features"),
            imageLink: getStaggaredDoubleFeautureFirstImage(intl.locale),
            imageAltText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.first-feature-alt-img-text",
                defaultMessage:
                    "image of Jira board showing todo and in-progress columns"
            }),
            analyticsEventLabel: "atlas-55799-jira-features-button-clicked"
        },
        {
            headingText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-header-text",
                defaultMessage: "Tailor it for your team"
            }),
            bodyText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-body-text",
                defaultMessage:
                    "Configure Jira to match your team’s processes, workflows, language, and more. Integrate with every tool you use to get work done."
            }),
            linkText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-link-text",
                defaultMessage: "Learn more"
            }),
            linkUrl: useLocalizedHref(
                "/software/jira/guides/issues/overview#what-is-an-issue"
            ),
            imageLink: getStaggaredDoubleFeautureSecondImage(intl.locale),
            imageAltText: intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.second-feature-alt-image-text",
                defaultMessage: "image of Jira issue detail view"
            }),
            analyticsEventLabel: "atlas-55799-jira-issues-button-clicked"
        }
    ];

    return (
        <StaggeredFeatureList
            mainHeadingText={intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.header-text",
                defaultMessage: "Bring every team together under one roof"
            })}
            subHeadingText={intl.formatMessage({
                id: "jira-product-tour.staggered-double-feature-section.subheader-text",
                defaultMessage:
                    "Spend less time trying to get aligned and more time driving projects forward with confidence."
            })}
            featureData={featureData}
            startingImagePosition="left"
        />
    );
};
BuildAndSupportDoubleFeatureSection.displayName =
    "BuildAndSupportDoubleFeatureSection";

export default BuildAndSupportDoubleFeatureSection;
